import React, { PureComponent, Fragment } from 'react';
import PropTypes from 'prop-types';
import Dropzone from 'react-dropzone';
import { FormattedMessage } from 'react-intl';
import OutlineCloudUpload from 'react-md-icon/dist/OutlineCloudUpload';

import { MAX_UPLOAD_SIZE_IN_BYTES, ACCEPTED_FILE_TYPES } from '../../constants';
import './UploadDropzone.scss';
import UploadContent from './UploadContent';

class UploadDropzone extends PureComponent {
  static encodeImage(file) {
    return new Promise((resolve) => {
      const reader = new FileReader();
      reader.onload = (event) => {
        const encodedFile = event.target.result;
        resolve({
          file,
          ...{ encodedFile },
        });
      };
      reader.readAsDataURL(file);
    });
  }

  constructor() {
    super();
    this.state = {
      files: [],
    };
    this.handleError = this.handleError.bind(this);
    this.onDrop = this.onDrop.bind(this);
  }

  onDrop(files) {
    this.setState({
      files,
    });
    UploadDropzone.encodeImage(files[0]).then((file) => {
      this.props.onDrop(file);
    });
  }

  onCancel() {
    this.setState({
      files: [],
    });
    this.props.onDrop(undefined);
  }

  handleError(files) {
    const { fileSizeLimit: limit } = this.props;
    const limitInMegabytes = limit / 1000000;

    if (files[0].size > this.props.fileSizeLimit) {
      this.props.onError([
        'danger',
        <Fragment>
          <FormattedMessage id="FILE_UPLOAD_CANNOT_EXCEED" /> { limitInMegabytes } <FormattedMessage id="FILE_SIZE_UNIT_MB" />
        </Fragment>,
        'drawer', // Location
        null, // visibilityTimeout
        true, // isDismissible
      ]);
    } else {
      this.props.onError([
        'danger',
        <FormattedMessage id="UNSUPPORTED_FILE_TYPE" />,
        'drawer', // Location
        null, // visibilityTimeout
        true, // isDismissible
      ]);
    }
  }

  render() {
    const dropzoneContentClasses = [
      'w-100', 'd-flex', 'align-items-center',
      'flex-column', 'justify-content-center', 'position-relative', 'p-3',
    ];
    const { files } = this.state;
    const {
      disabled, fileSizeLimit, iconSize,
    } = this.props;
    return (
      <section className="dropzone w-100" style={{ pointerEvents: `${disabled ? 'none' : 'auto'}` }}>
        <Dropzone
          accept={ACCEPTED_FILE_TYPES}
          maxSize={fileSizeLimit}
          onDropAccepted={this.onDrop}
          onDropRejected={this.handleError}
        >
          {({ getRootProps, getInputProps, isDragActive }) => {
              const classes = isDragActive ? [...dropzoneContentClasses, 'drag-over'] : dropzoneContentClasses;
              if (files[0]) return <UploadContent file={files[0]} handleClose={this.onCancel.bind(this)} contentSize={iconSize} />;
              return (
                <div
                  {...getRootProps()}
                  className={classes.join(' ')}
                >
                  <input {...getInputProps()} />
                  <OutlineCloudUpload
                    className="upload-icon"
                    style={{ fontSize: iconSize, color: 'var(--color-neutral-300)' }}
                  />
                  <h5 className="text-center font-weight-light mb-0"><FormattedMessage id="DROP_A_DOCUMENT_HERE" /></h5>
                  <p className="mb-0">
                    <FormattedMessage id="OR" />
                    <span>&nbsp;
                      <span
                        onClick={e => e.preventDefault()}
                        onKeyPress={e => e.preventDefault()}
                        role="presentation"
                        className="btn-link"
                      >
                        <FormattedMessage id="CHOOSE_A_FILE" />
                      </span>
                    </span>
                  </p>
                </div>
              );
            }
          }
        </Dropzone>
      </section>
    );
  }
}

UploadDropzone.defaultProps = {
  onError: () => {},
  disabled: false,
  iconSize: '8rem',
  fileSizeLimit: MAX_UPLOAD_SIZE_IN_BYTES,
};

UploadDropzone.propTypes = {
  onDrop: PropTypes.func.isRequired,
  onError: PropTypes.func,
  disabled: PropTypes.bool,
  iconSize: PropTypes.string,
  fileSizeLimit: PropTypes.number,
};

export default UploadDropzone;



// WEBPACK FOOTER //
// ./src/components/UploadDropzone/UploadDropzone.jsx